// extracted by mini-css-extract-plugin
export default {"root":"StripePaymentAddress_root__-+3o-","formRow":"StripePaymentAddress_formRow__9lDrK","zipHint":"StripePaymentAddress_zipHint__OmNjL","field":"StripePaymentAddress_field__mdaKh"};